import React, { useEffect } from "react";
import StudyInIndia from "././components/StudyInIndia";
import Navbar from "src/Component/Navbar";
import { Helmet } from "react-helmet";
import WhyStudyInIndia from "./components/WhyStudyInIndia";
import CoursesOffered from "./components/CoursesOffered";
import { IndiaPopular } from "src/CountryPages/CountryInfo/CountryInfoJson/CountryPopular";
import IndianUniversities from "./components/IndianUniversities";
import { Box } from "@mui/material";
import Footer from "src/Component/Footer";

const MainIndiaPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div>
      <Helmet>
        <title>International Engagement : India | Taksheela Institute</title>
      </Helmet>
      <Navbar />
      <StudyInIndia />
      <WhyStudyInIndia />
      <CoursesOffered courses={IndiaPopular} />
      <IndianUniversities />
      <Box sx={{ pt: 5 }}>
        <Footer />
      </Box>
    </div>
  );
};

export default MainIndiaPage;
